import { render, staticRenderFns } from "./SelectPersonType.vue?vue&type=template&id=087ed986&scoped=true&"
import script from "./SelectPersonType.vue?vue&type=script&lang=js&"
export * from "./SelectPersonType.vue?vue&type=script&lang=js&"
import style0 from "./SelectPersonType.vue?vue&type=style&index=0&id=087ed986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087ed986",
  null
  
)

export default component.exports